import { render, staticRenderFns } from "./goodsCenter.vue?vue&type=template&id=5117ded8&"
import script from "./goodsCenter.vue?vue&type=script&lang=js&"
export * from "./goodsCenter.vue?vue&type=script&lang=js&"
import style0 from "./goodsCenter.vue?vue&type=style&index=0&id=5117ded8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports